import { SubscriptionEnum } from './enums';

export class EditionId {
  public static currentEdition(subscriptionId: number): number {
    return (
      subscriptionId * 1000000 +
      new Date().getFullYear() * 100 +
      (new Date().getMonth() + 1)
    );
  }

  public static incrementEdition(editionId: number, increment: number): number {
    const editionDate = new Date(
      `${this.year(editionId)}-${this.month(editionId).toString().padStart(2, '0')}-05`
    );
    const incrementedDate = new Date(
      editionDate.setMonth(editionDate.getMonth() + increment)
    );
    return Number(
      this.subscriptionId(editionId).toString() +
        incrementedDate.getFullYear() +
        (incrementedDate.getMonth() + 1).toString().padStart(2, '0')
    );
  }

  public static isBefore(
    editionBefore: number,
    currentEdition: number
  ): boolean {
    return (
      this.yearMonthReference(editionBefore) <
      this.yearMonthReference(currentEdition)
    );
  }

  public static isBeforeOrEqual(
    editionBefore: number,
    currentEdition: number
  ): boolean {
    return (
      this.yearMonthReference(editionBefore) <=
      this.yearMonthReference(currentEdition)
    );
  }

  public static isAfter(editionAfter: number, currentEdition: number): boolean {
    return (
      this.yearMonthReference(editionAfter) >
      this.yearMonthReference(currentEdition)
    );
  }

  public static isAfterOrEqual(
    editionAfter: number,
    currentEdition: number
  ): boolean {
    return (
      this.yearMonthReference(editionAfter) >=
      this.yearMonthReference(currentEdition)
    );
  }

  public static yearMonthReference(editionId: number) {
    return editionId % 1000000;
  }

  public static subscriptionId(editionId: number) {
    return Number((editionId / 1000000).toFixed(0));
  }

  public static year(editionId: number) {
    return Number((this.yearMonthReference(editionId) / 100).toFixed(0));
  }

  public static month(editionId: number) {
    return editionId % 100;
  }

  public static isCombo(editionId: number): boolean {
    return [
      SubscriptionEnum.Glamcombo,
      SubscriptionEnum['Glamcombo Premium']
    ].includes(this.subscriptionId(editionId));
  }

  public static isPremium(editionId: number): boolean {
    return [
      SubscriptionEnum['Glambox Premium'],
      SubscriptionEnum['Glambag Premium'],
      SubscriptionEnum['Glamcombo Premium']
    ].includes(this.subscriptionId(editionId));
  }
}
